import { isNilOrEmpty, toTitleCase } from '@benzinga/utils';
import { GroupBy } from './entity';

export const getGroupCategory = (groupBy: GroupBy) => {
  if (isNilOrEmpty(groupBy)) return ['gicsSectorName'];
  switch (groupBy) {
    case 'sector':
      return ['gicsSectorName'];
    case 'industry':
      return ['gicsIndustryName'];
    case 'combined':
      return ['gicsSectorName', 'gicsIndustryName'];
    case 'allSymbols':
      return ['allSymbols'];
  }
};

export const getDefaultLabel = (groupBy: GroupBy) => {
  if (isNilOrEmpty(groupBy)) return 'All Symbols';
  switch (groupBy) {
    case 'sector':
    case 'industry':
      return `Other ${toTitleCase(groupBy)}`;
    case 'combined':
      return 'Other Sector/Industry';
    case 'allSymbols':
      return 'All Symbols';
    default:
      return '';
  }
};
